import { ApolloClient, InMemoryCache } from "@apollo/client";
import { origins } from "./environment-urls";

export default new ApolloClient({
  uri: origins.graphql,
  cache: new InMemoryCache(),
});
